import * as angular from "angular";
import {integrationDocumentationModule, integrationValidatorModule, remoteRoutingModule} from "programming-front-end";

import "front-end-web-commons/app/remoteServer/remoteServer";

export const configParamsModule = angular.module("configParamsModule", [
    integrationDocumentationModule.name,
    integrationValidatorModule.name,
    remoteRoutingModule.name,
    "remoteServerModule"
]);
